var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsPane',{attrs:{"header":_vm.keywords_title,"icon":'tag',"has_items":!!_vm.project.keywords,"is_open_initially":true,"can_be_toggled":false}},[_c('div',{},[_c('TagsField',{attrs:{"label":_vm.$t('keywords'),"field_name":'keywords',"tag_type":'keywords',"content":_vm.project.keywords,"path":_vm.project.$path,"can_edit":_vm.can_edit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }